import {Context, createContext} from "react";

const BlogsContext: Context<any> = createContext({});

export {BlogsContext}